import React, { Component } from 'react';
import  createHistory  from 'history/createBrowserHistory';
import "./css/wepcg_bar.css"

class DOAHelp_hints extends Component{
    constructor(props) {
        super(props);
        this.history = createHistory();
    }
    render() {
        return <div>
            <p>Help /Hints:</p>
            <ul>
                <li>
                    1. <strong>Serial Number: </strong>User first input Serial Number, then click new button 'Validate' , will trigger the SN validation and pop up order items details window, or pop up Error message to stop the process;
                </li>
                <br/>
                <li>
                    2. Then user selecting items details and choose ‘OK’ in pop up windows, Below relevant invoice information will be populated into portal fields automatically. these auto populated fields value cannot be edited:
                </li>
                <li>
                    <strong>Invoice Number</strong>
                </li>
                <li>
                    <strong>Sold-to Number</strong>
                </li>
                <li>
                    <strong>PO Number</strong>
                </li>
                <li>
                    <strong>Delivery Number</strong>
                </li>
                <li>
                    <strong>Order Number</strong>
                </li>
                <li>
                    <strong>Currency</strong>
                </li>
                <br/>
                <li>
                    3. All fields with * are mandatory fields
                </li>
                <br/>
                <li>
                    4. Click the button “ + “ to add more items record
                </li>
            </ul>
        </div>
    }
}

export default DOAHelp_hints;